<template>
  <v-btn icon flat small @click="goRoute">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">launch</v-icon>
      <span>Ver contrato</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goRoute () {
      this.$router.push({ name: 'detalleContrato', params: { id: this.item.id } })
    }
  }
}
</script>
